<script setup>
import { EyeIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useRoute } from "@js/utils/route";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const { route } = useRoute();
</script>

<template>
  <div class="flex h-full flex-row items-center gap-2 p-4">
    <ActionButton
      size="small"
      class="size-8"
      :title="t('button.see')"
      :href="
        route('front.projectManagement.sem.emailings', {
          tenant: row.original.id,
        })
      "
      :icon="EyeIcon"
    />
  </div>
</template>
